// Match TeamLobby: only work still in flight pauses a new player action.
// Review-required operations remain in the backend audit/reconciliation data,
// but they must not turn a game card into a permanent disabled state.
export const isBlockingGameOperation = (operation) => (
  ['pending', 'processing', 'queued'].includes(String(operation?.status || '').toLowerCase())
);
